Trip = {
    itemsCarousel: null,
    skipMarkerZoom: false,

    init: function () {

        this.itemsCarousel = new Swiper('.places-box-slider .swiper-container', {
            nextButton: '.places-box-slider .next-button',
            prevButton: '.places-box-slider .prev-button',
            slidesPerView: 1,
            roundLengths: true,
            loop: true,
            onSlideChangeStart: function (swiper) {

                if (Trip.skipMarkerZoom) {
                    return;
                }

                var activeSlide = $('.swiper-slide-active');
                var object = TSGMap.objects[activeSlide.data('id')];
                if (object !== undefined) {
                    TSGMap.moveToObject(object, true);
                }
            },
            onTransitionEnd: function (swiper) {
                Trip.skipMarkerZoom = false;
            }
        });

        TSGMap.objectClick = function (object) {
            var id = object.id;
            Trip.skipMarkerZoom = true;
            $('.swiper-slide .card').each(function (index) {
                if ($(this).data('id') == id) {
                    Trip.itemsCarousel.slideTo(index);
                }
            });
        };

        $.get( $('#map').data('track-url'), function( data ) {

            TSGMap.addObjects(data.objects);
            TSGMap.initMarkerEvents();

            if(data.track.length < 2)
                return;
            TSGMap.addTrack(data.track);
        }, 'json');

    }
};



$(function() {
    Trip.init();
});